// extracted by mini-css-extract-plugin
module.exports = {"header":"header___3t0Xc","banner":"banner___2fxZr"};